import { SingleColorOptions } from 'meditopia-ui/theme/colors'
import getThemeColor from './getThemeColor'

const styledColor =
  (darkKey: SingleColorOptions, lightKey?: SingleColorOptions) =>
  ({ theme }: { theme: any }) =>
    getThemeColor(theme, darkKey, lightKey)

export default styledColor
